import Contacts from './Contacts.js';

export default Contacts;
